import At from '@components/Icons/At';
import * as ApiModels from '@typings/api-models';
import BaseAnswer from './BaseAnswer';
import s from '../QuestionAndAnswer.module.scss';

type Props = {
  field: ApiModels.FormResponseEmailField;
};

const EmailAnswer: React.FC<Props> = ({ field: { answer } }) => (
  <div className={s.answer}><At weight='regular' /><BaseAnswer answer={answer} /></div>
);

export default EmailAnswer;
